import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { SYSTEM_OUTPUT } from './topics';

export const STATUS_UPDATE = 'SYSTEM/STATUS_UPDATE' as const;

export interface IStatusUpdateAction {
  type: typeof STATUS_UPDATE;
  payload: {
    consoleId: string;
    timestamp: number;
    mode: 'sleep' | 'wake';
    status: 'pending' | 'completed';
    forced: boolean;
  };
}

export const statusUpdateActionSchema = objectSchemaOf<IStatusUpdateAction>({
  type: Joi.string().valid(STATUS_UPDATE).required(),
  payload: objectSchemaOf<IStatusUpdateAction['payload']>({
    consoleId: Joi.string().required(),
    timestamp: Joi.number().required(),
    mode: Joi.string().valid('sleep', 'wake').required(),
    status: Joi.string().valid('pending', 'completed').required(),
    forced: Joi.boolean().required(),
  }).required(),
});

export const statusUpdate = actionCreator({
  type: STATUS_UPDATE,
  topic: SYSTEM_OUTPUT,
  schema: statusUpdateActionSchema,
});
